import React, { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { faBars, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../assets/Images/logo/WelearnLogo.jpg";

export default function Header() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [activeLink, setActiveLink] = useState("Home");

  const handleLinkClick = (linkName) => {
    setActiveLink(linkName);
    if (mobileMenuOpen) {
      toggleMobileMenu();
    }
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -50;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    console.log("Mobile menu toggled");
  };

  return (
    <>
      <header
        id="header"
        className={`fixed-top ${
          scrolled ? "header-scrolled" : "header-transparent"
        }`}
      >
        <div className="container d-flex align-items-center justify-content-between">
          <div className="logo">
            <Link
              to="/"
              onClick={() => {
                scrollToTop();
                handleLinkClick("Home");
              }}
              className={`nav-link scrollto ${
                activeLink === "Home" ? "active" : ""
              }`}
            >
              <img src={logo} className="img-fluid" alt="WeLearn" />
            </Link>
          </div>

          <nav
            id="navbar "
            className={`navbar  ${mobileMenuOpen ? "mobile-nav-open" : ""}`}
          >
            <ul>
              <li>
                <Link
                  to="/"
                  onClick={() => {
                    scrollToTop();
                    handleLinkClick("Home");
                  }}
                  className={`nav-link scrollto ${
                    activeLink === "Home" ? "active" : ""
                  }`}
                >
                  Home
                </Link>
              </li>

              <li>
                <HashLink
                  className={`nav-link scrollto ${
                    activeLink === "AppFeatures" ? "active" : ""
                  }`}
                  to="/#appfeatures"
                  onClick={() => handleLinkClick("AppFeatures")}
                  scroll={(el) => scrollWithOffset(el)}
                >
                  App Features
                </HashLink>
              </li>

              <li>
                <HashLink
                  className={`nav-link scrollto ${
                    activeLink === "Gallery" ? "active" : ""
                  }`}
                  to="/#gallery"
                  onClick={() => handleLinkClick("Gallery")}
                  scroll={(el) => scrollWithOffset(el)}
                >
                  Overview
                </HashLink>
              </li>

              {/* <li><HashLink className={`nav-link scrollto ${activeLink === 'Team' ? 'active' : ''}`}
            to="#team"
            onClick={() => handleLinkClick('Team')}>Team</HashLink></li> */}

              {/* <li><HashLink className=className={`nav-link scrollto ${activeLink === 'Pricing' ? 'active' : ''}`}
            to="#pricing"
            onClick={() => handleLinkClick('Team')}>Pricing</HashLink></li> */}

              {/* <li><HashLink className={`nav-link scrollto ${activeLink === 'FAQ' ? 'active' : ''}`}
            to="#faq"
            onClick={() => handleLinkClick('Team')}>F.A.Q</HashLink></li> */}

              {/* <li className="dropdown"><a href="/"><span>Drop Down</span><FontAwesomeIcon icon={faChevronUp} className='mx-1'/></a>
              <ul>
                <li><a href="/">Drop Down 1</a></li>
                <li className="dropdown"><a href="/"><span>Deep Drop Down</span> <FontAwesomeIcon icon={faChevronRight}/></a>
                  <ul>
                    <li><a href="/">Deep Drop Down 1</a></li>
                    <li><a href="/">Deep Drop Down 2</a></li>
                    <li><a href="/">Deep Drop Down 3</a></li>
                    <li><a href="/">Deep Drop Down 4</a></li>
                    <li><a href="/">Deep Drop Down 5</a></li>
                  </ul>
                </li>
                <li><a href="/">Drop Down 2</a></li>
                <li><a href="/">Drop Down 3</a></li>
                <li><a href="/">Drop Down 4</a></li>
              </ul>
            </li> */}

              <li>
                <HashLink
                  className={`nav-link scrollto ${
                    activeLink === "Contact" ? "active" : ""
                  }`}
                  to="/#contact"
                  onClick={() => handleLinkClick("Contact")}
                  scroll={(el) => scrollWithOffset(el)}
                >
                  Contact
                </HashLink>
              </li>

              {/* <li><Link className="getstarted scrollto" to="/features">Get Started</Link></li> */}
            </ul>
            <FontAwesomeIcon
              icon={mobileMenuOpen ? faX : faBars}
              className="mobile-nav-toggle"
              onClick={toggleMobileMenu}
            />
            {mobileMenuOpen && (
              <FontAwesomeIcon
                icon={faX}
                className="mobile-nav-toggle"
                style={{ color: "white" }}
                onClick={toggleMobileMenu}
              />
            )}
          </nav>
        </div>
      </header>
    </>
  );
}
